import { render, staticRenderFns } from "./SsoConfiguration.vue?vue&type=template&id=9faf538e&scoped=true"
import script from "./SsoConfiguration.vue?vue&type=script&lang=ts"
export * from "./SsoConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./SsoConfiguration.vue?vue&type=style&index=0&id=9faf538e&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faf538e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZInput: require('/app/components/zeal/ZInput/ZInput.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZAlert: require('/app/components/zeal/ZAlert/ZAlert.vue').default})
